<div class="main-div position-absolute" #dialog ngDraggable>
  <button class="close-btn" (click)="closeDialog()">✖</button>
  <div class="dialog position-relative">
    <div class="content">
      <h2 class="mb-4">{{ takeOffLengthHeader }}</h2>
      <div class="d-flex mb-4 align-items-center">
        <input class="flex-1 service-type border" type="text" [(ngModel)]="takeOffLength" />
      </div>
      @if (isAlertVisible) {
        <div class="sysque-alert">
          <alert [alert]="alert" (alertClosed)="hideAlert()"></alert>
        </div>
      }
      <div class="actions d-flex">
        <button class="btn btn-primary ml-1 flex-1" (click)="applyChanges()">Add</button>
      </div>
    </div>
  </div>
</div>
